//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import { mapState } from 'vuex'

export default {
  data() {
    return {
      servicesHidden: true,
      locationsHidden: true,
      column1: [ 'mon', 'tue', 'wed', 'thu' ],
      column2: [ 'fri', 'sat', 'sun' ]
    };
  },
  props: {
    location: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapState([ 'order' ]),
    locationURI() {
      let address = this.location.address+', '+this.location.city+', '+this.location.state+' '+this.location.zip
      return encodeURIComponent(address)
    },
    dayOfWeek() {
      return moment().format('ddd').toLowerCase()
    },
  },
  methods: {
    getHours(day) {
      const hours = this.location.hours.find(hour => hour.day === day)

      if (!hours || !hours.open) {
        return 'Closed'
      }

      if (hours.open == hours.close) {
        return 'Open 24 hours'
      } else {
        const hoursFormatted = `${moment(hours.open, 'H:mm').format('h:mma')}-${moment(hours.close, 'H:mm').format('h:mma')}`
        return hoursFormatted.replace(/\:00/g, '')
      }

      // Hard Coded Option
      // else if (day === 'Monday' || day === 'Tuesday' || day === 'Wednesday' || day === 'Thursday') {
      //   if (this.location.city === 'Corpus Christi' || this.location.city === 'Lubbock' || this.location.city === 'Oklahoma City' || this.location.city === 'Pasaden' || this.location.city === 'Tyler') {
      //     return '11am-9pm'
      //   } else {
      //     return '11am-10pm'
      //   }
      // } else if (day === 'Friday' || day === 'Saturday') {
      //   return '11am-11pm'
      // } else {
      //   return '11am-10pm'
      // }
    },
    getDay(day) {
      return moment().day(day).format('dddd')
    },
    // Old method - replace by GM 1/18
    // async startOrder() {
    //   let location = await this.$api.getLocation(this.location.id)
    //   this.$store.commit('setLocation', location)
    //   await this.$api.getMenu()
    //   let order = null
    //   if(this.order && this.order.menu_id != location.menu_id) {
    //     order = await this.$api.transferOrder()
    //   } else {
    //     order = await this.$api.startOrder()
    //   }
    //   if(order) {
    //     this.$router.push('/order/')
    //   }
    // },
    async startOrder(loc) {
      let location = await this.$api.getLocation(loc.id)
      this.$store.commit('setLocation', location)
      this.$store.commit('setMenu', null)
      this.$store.commit('setOrder', null)
      this.$store.commit('setOrderTypePicker', true)
    },
    async selectTime(time) {
      if(time == 'close') {
        this.showTime = false
      } else {
        let handoff_time = time
        if(time == 'asap') {
          let earliest = moment(this.location.calendar.default[0].open, 'YYYYMMDD HH:mm')
          let latest = moment(this.location.calendar.default[0].close, 'YYYYMMDD HH:mm')
          if(moment() < earliest) {
            handoff_time = this.location.calendar.default[0].open
          } else if(moment() > latest) {
            handoff_time = this.location.calendar.default[1].open
          } else {
            handoff_time = null
          }
        }
        await this.$api.getMenu(false, true, handoff_time)
        let order = await this.$api.createOrder(handoff_time)
        if(order) {
          this.$router.push('/order/')
        }
      }
    },
    phone(s) {
      let cleaned = ('' + s).replace(/\D/g, '')
      let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
      if (match) {
        return '(' + match[1] + ') ' + match[2] + '-' + match[3]
      }
      return null
    }
  //   getDate(o) {
  //     // console.log(o);
  //     // return moment(o.time.placed, "YYYYMMDD HH:mm").format('LLL');
  //     return moment(o.time.placed, "YYYYMMDD HH:mm").format('MMMM D LT');
  //   },
  },
  mounted() {
    this.$store.commit('setOpaque', true)
  }
};
